import { getTelemetryHostingConfig } from '@ms/yammer-telemetry-store';

import { getOperationNameFromServerTiming, getResourceEntryType } from './resourceParser';
import type { ResourceEntryType } from './types';

const graphqlOperationsToExclude = ['ReportTelemetryEventsClients'];

const isValidGraphqlOperation = (serverTiming: readonly PerformanceServerTiming[]) => {
  const operationName = getOperationNameFromServerTiming(serverTiming);

  return !!operationName && !graphqlOperationsToExclude.includes(operationName);
};

const isReportableGraphqlResourceEntry = (resourceEntry: PerformanceResourceTiming) =>
  !!resourceEntry.serverTiming && isValidGraphqlOperation(resourceEntry.serverTiming);

const isReportableStaticAssetResourceEntry = (resourceEntry: PerformanceResourceTiming) => {
  const hostingConfig = getTelemetryHostingConfig();
  if (!hostingConfig) {
    return false;
  }

  const cdnBaseUrl = hostingConfig.cdnBaseUrl;
  if (cdnBaseUrl) {
    const cdnBaseUrlWithoutProtocol = cdnBaseUrl.replace(/^(https?:)?\/\//, '');

    return resourceEntry.name.indexOf(cdnBaseUrlWithoutProtocol) > -1;
  }

  return false;
};

const reportableResourceEntryTypes: ResourceEntryType[] = ['Flighting', 'GraphQL', 'JavaScript', 'Image'];

type IsReportableResourceEntry = (resourceEntry: PerformanceResourceTiming) => boolean;
export const isReportableResourceEntry: IsReportableResourceEntry = (resourceEntry) => {
  const resourceType = getResourceEntryType(resourceEntry);

  switch (resourceType) {
    case 'GraphQL':
      return isReportableGraphqlResourceEntry(resourceEntry);
    case 'JavaScript':
      return isReportableStaticAssetResourceEntry(resourceEntry);
    case 'CSS':
      return isReportableStaticAssetResourceEntry(resourceEntry);
    default:
      return reportableResourceEntryTypes.includes(resourceType);
  }
};
